import { Children, PureComponent } from 'react';
import type { FormEvent, ReactNode } from 'react';
// import { Style, StatusBar } from '@capacitor/status-bar';
import { slugify } from '@utilities/slugify';
import ModalPortal from '../ModalPortal';

export interface Props {
  title?: ReactNode;
  asForm?: boolean;
  isNaked?: boolean;
  children?: ReactNode;
  blurTargetId?: string;
  fullscreen?: boolean;
  hideHeader?: boolean;
  hideFooter?: boolean;
  scrollable?: boolean;
  removeWindowScroll?: boolean;
  // Labels
  primaryLabel?: string;
  secondaryLabel?: string;
  // Hiding
  hideClose?: boolean;
  hidePrimary?: boolean;
  hideSecondary?: boolean;
  // Loading
  isLoading?: boolean;
  primaryLoading?: boolean;
  secondaryLoading?: boolean;
  // Disabled
  disabled?: boolean;
  primaryDisabled?: boolean;
  secondaryDisabled?: boolean;
  // Callbacks
  onClose?: (id: string) => void;
  onPrimaryClick?: (
    e: FormEvent | MouseEvent | KeyboardEvent,
    id: string
  ) => void;
  onSecondaryClick?: (id: string) => void;
}

class Modal extends PureComponent<Props> {
  static defaultProps = {
    list: [],
    title: '',
    asForm: false,
    isNaked: false,
    disabled: false,
    children: null,
    isLoading: false,
    hideSecondary: false,
    scrollable: true,
    secondaryLabel: 'Close',
    hidePrimary: false,
    primaryLabel: 'Confirm',
    hideClose: false,
    hideHeader: false,
    hideFooter: false,
    fullscreen: false,
    removeWindowScroll: true,
    primaryLoading: false,
    secondaryLoading: false,
    primaryDisabled: false,
    secondaryDisabled: false,
  };

  async componentDidMount() {
    const { fullscreen } = this.props;
    if (fullscreen) {
      try {
        if (RUNTIME_ENV === 'native') {
          const { Style, StatusBar } = await import('@capacitor/status-bar');
          await StatusBar.setStyle({
            style: Style.Light,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  async componentWillUnmount() {
    const { fullscreen } = this.props;
    if (fullscreen) {
      try {
        if (RUNTIME_ENV === 'native') {
          const { Style, StatusBar } = await import('@capacitor/status-bar');
          await StatusBar.setStyle({
            style: Style.Dark,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  handleClose = (id = '') => {
    const { onClose, onSecondaryClick } = this.props;
    if (onClose && typeof onClose === 'function') {
      onClose(id);
    } else if (onSecondaryClick && typeof onSecondaryClick === 'function') {
      onSecondaryClick(id);
    } else {
      console.log('Please set a close action or secondary action');
    }
  };

  render() {
    const { handleClose } = this;
    const {
      title,
      asForm,
      isNaked,
      disabled,
      children,
      isLoading,
      hideClose,
      scrollable,
      hidePrimary,
      hideSecondary,
      primaryLabel,
      secondaryLabel,
      blurTargetId,
      hideHeader,
      hideFooter,
      fullscreen,
      removeWindowScroll,
      primaryLoading,
      secondaryLoading,
      primaryDisabled,
      secondaryDisabled,
      onPrimaryClick,
      onSecondaryClick,
    } = this.props;
    return (
      <>
        {Children.map(children, (n, i) => {
          const id = `ModalPortal-${i}-${
            typeof title === 'string' ? slugify(title || '') : ''
          }`;
          return (
            <ModalPortal
              id={id}
              key={id}
              asForm={asForm as boolean}
              title={title as string}
              isNaked={isNaked as boolean}
              scrollable={scrollable as boolean}
              disabled={disabled as boolean}
              isLoading={isLoading as boolean}
              fullscreen={fullscreen as boolean}
              hideSecondary={hideSecondary as boolean}
              blurTargetId={blurTargetId as string}
              secondaryLabel={secondaryLabel as string}
              onClose={handleClose}
              onPrimaryClick={onPrimaryClick}
              onSecondaryClick={onSecondaryClick}
              hidePrimary={hidePrimary as boolean}
              primaryLabel={primaryLabel as string}
              hideClose={hideClose as boolean}
              primaryLoading={primaryLoading as boolean}
              secondaryLoading={secondaryLoading as boolean}
              primaryDisabled={primaryDisabled as boolean}
              secondaryDisabled={secondaryDisabled as boolean}
              hideHeader={hideHeader as boolean}
              hideFooter={hideFooter as boolean}
              removeWindowScroll={removeWindowScroll as boolean}
            >
              {n}
            </ModalPortal>
          );
        })}
      </>
    );
  }
}

export default Modal;
